import { css } from 'styled-jsx/css';

export default css`
  button {
    width: auto;
    min-width: unset;
    display: inline;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    color: #fd0300;
    font-size: 16px;
  }

  button:hover {
    text-decoration: underline;
  }
`;
